module.exports = __webpack_public_path__ + "img/kikikiki.c07694bd.png";